<template>
  <v-container fluid class="pa-5">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <template v-if="!isLoading">
      <template v-if="categories.length === 0 && !search">
        <v-card class="card-container d-flex pa-6" elevation="0">
          <v-row>
            <v-col cols="12">
              <span class="title-text">จัดการหมวดหมู่</span>
            </v-col>

            <v-col
              cols="12"
              class="d-flex flex-column align-center justify-center"
              style="min-height: 88vh"
            >
              <div class="d-flex flex-column align-center">
                <v-img>
                  <img
                    src="@/assets/not_exist_search.svg"
                    alt="no-data"
                    width="103"
                    height="103"
                  />
                </v-img>
                <span class="no-data-text mb-4"> ยังไม่มีรายการหมวดหมู่ </span>

                <v-btn
                  color="#F4811F"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreateModal"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  สร้างหมวดหมู่ใหม่
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-else>
        <v-card class="card-container pa-2" elevation="0">
          <v-card-title>
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-start"
              >
                <span class="title-text">จัดการหมวดหมู่</span>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-end"
              >
                <v-btn
                  color="#F4811F"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreateModal"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  สร้างหมวดหมู่ใหม่
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    v-model="search"
                    placeholder="ค้นหาหมวดหมู่..."
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    class="rounded-lg"
                    style="max-width: 400px"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-4">
                <template v-if="filteredCategories.length > 0">
                  <CategoryTable
                    :items="filteredCategories"
                    @edit="openEditModal"
                    @delete="confirmDelete"
                  />
                </template>

                <template v-else>
                   <v-row>
                    <v-col
                      cols="12"
                      class="d-flex flex-column align-center justify-center"
                      style="min-height: 45vh"
                    >
                      <div class="d-flex flex-column align-center">
                        <v-img>
                          <img
                            src="@/assets/not_exist_search.svg"
                            alt="no-data"
                            width="103.8"
                            height="103.8"
                          />
                        </v-img>
                        <span class="no-data-text mb-4">
                          ไม่พบข้อมูลที่ค้นหา กรุณาลองใหม่อีกครั้ง
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </template>
    
    <CategoryDialog 
        v-model="dialog"
        :item="editedItem"
        :mode="editedIndex === -1 ? 'create' : 'edit'"
        @save="handleSave"
    />

  </v-container>
</template>

<script>
import CategoryTable from "@/components/AdminCategory/Table.vue";
import CategoryDialog from "@/components/AdminCategory/Dialog.vue";
import { 
    getCategoriesAdminApi, 
    createCategoryApi, 
    updateCategoryApi, 
    deleteCategoryApi 
} from "@/services/api/category";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "AdminCategory",
  components: {
    CategoryTable,
    CategoryDialog
  },

  data() {
    return {
      isLoading: false,
      categories: [],
      search: "",
      
      dialog: false,
      editedIndex: -1,
      editedItem: {},
    };
  },

  async created() {
    await this.loadCategories();
  },

  computed: {
    filteredCategories() {
      if (!this.search) {
        return this.categories;
      }
      const lowerSearch = this.search.toLowerCase();
      return this.categories.filter(c => 
        (c.name || "").toLowerCase().includes(lowerSearch)
      );
    },
  },

  methods: {
    async loadCategories() {
      this.isLoading = true;
      try {
        const res = await getCategoriesAdminApi();
        // Adjust response reading based on API structure (assumed res.data.data from Board example)
        if (res.data) {
             // API structure might be res.data directly or res.data.data
             // Based on board: res.data.data
             // Let's assume standard response, check both
             this.categories = Array.isArray(res.data) ? res.data : (res.data.data || []);
        } else {
             this.categories = [];
        }
      } catch (error) {
        console.error("Error loading categories:", error);
        swalAlert.Error("โหลดข้อมูลหมวดหมู่ล้มเหลว");
      } finally {
        this.isLoading = false;
      }
    },

    openCreateModal() {
        this.editedIndex = -1;
        this.editedItem = null;
        this.dialog = true;
    },

    openEditModal(item) {
        this.editedIndex = this.categories.indexOf(item);
        this.editedItem = item;
        this.dialog = true;
    },

    async handleSave(payload) {
        if (!payload.name) {
             swalAlert.Warning("กรุณากรอกชื่อหมวดหมู่");
             return;
        }
        
        this.isLoading = true;
        try {
            if (this.editedIndex > -1) {
                // Update
                // Note: payload has all fields from localItem in dialog
                // item contains _id or id
                const id = this.editedItem.id || this.editedItem._id;
                console.log(id, payload);
                await updateCategoryApi(id, { name: payload.name, isActive: payload.isActive });
                swalAlert.Success("อัปเดตข้อมูลสำเร็จ");
            } else {
                // Create
                await createCategoryApi({ name: payload.name, isActive: payload.isActive });
                 swalAlert.Success("สร้างหมวดหมู่สำเร็จ");
            }
            this.dialog = false;
            await this.loadCategories();
        } catch (error) {
             console.error("Error saving category:", error);
             swalAlert.Error("บันทึกข้อมูลล้มเหลว");
        } finally {
            this.isLoading = false;
        }
    },

    async confirmDelete(item) {
        const result = await swalAlert.Confirm({
            title: "ยืนยันการลบ",
            message: `คุณต้องการลบหมวดหมู่ "${item.name}" ใช่หรือไม่?`
        });

        if (result.isConfirmed) {
            this.isLoading = true;
            try {
                const id = item.id || item._id;
                await deleteCategoryApi(id);
                swalAlert.Success("ลบข้อมูลสำเร็จ");
                await this.loadCategories();
            } catch (error) {
                 console.error("Error deleting category:", error);
                 swalAlert.Error("ลบข้อมูลล้มเหลว");
            } finally {
                this.isLoading = false;
            }
        }
    }
  },
};
</script>

<style scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}
.no-data-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.card-container {
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
}
.create-btn {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 40px !important;
  text-transform: none !important;
}
@media (max-width: 960px) {
  .create-btn {
    width: 100% !important;
  }
}
</style>